// Function to add an item to session storage
export const addToSessionStorageAsync = (key, value) => {
  return new Promise((resolve, reject) => {
    try {
      // Convert value to string format if it's an object
      const stringValue =
        typeof value === 'object' ? JSON.stringify(value) : value;
      // Add the key-value pair to session storage
      sessionStorage.setItem(key, stringValue);
      resolve(`Item added to session storage: ${key}`);
    } catch (error) {
      reject(error); // Reject the promise if an error occurs
    }
  });
};

export const readFromSessionStorageAsync = (key) => {
  return new Promise((resolve, reject) => {
    let item;
    try {
      item = sessionStorage.getItem(key);
      if (!item) {
        // Resolve with null if the key does not exist
        resolve(null);
      } else {
        // Attempt to parse the item as JSON and resolve it
        resolve(JSON.parse(item));
      }
    } catch (error) {
      // If parsing fails, resolve with the item as a string instead of rejecting
      // to maintain the behavior similar to your original function.
      // However, if you prefer to treat parsing error as a failure, you can use reject(error);
      resolve(item);
    }
  });
};
